// elements/phone-badge-check-42.js
import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/phone-badge-check/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.phone-badge-check":"Smarttelefon med et sjekkmerke"}');

// src/raw/phone-badge-check/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.phone-badge-check":"Smartphone and a badge with a check mark"}');

// src/raw/phone-badge-check/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.phone-badge-check":"\xC4lypuhelin ja valintamerkki"}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages4 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages4);
  i18n.activate(locale);
};

// elements/phone-badge-check-42.js
activateI18n(messages2, messages, messages3);
var IconPhoneBadgeCheck42 = class extends LitElement {
  render() {
    const title = i18n2.t({ message: `Smartphone and a badge with a check mark`, id: "icon.title.phone-badge-check", comment: "Title for phone badge check icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-phone-badge-check-42-part">${unsafeStatic(`<title>${title}</title>`)}<g stroke="currentColor" stroke-width="2"><path stroke-linecap="round" d="m23.428 5-.348-.522a1.71 1.71 0 0 0-1.426-.764H11c-.947 0-1.714.768-1.714 1.715v18c0 .946.767 1.714 1.714 1.714h11.143c.947 0 1.714-.768 1.714-1.714v-2.572"></path><path stroke-linecap="round" stroke-linejoin="round" d="M10.143 21.714H23"></path><path stroke-linecap="round" d="M15.286 7.143h2.571"></path><path d="M28.737 5.932a1.45 1.45 0 0 1 2.24 0l.75.912c.308.373.78.569 1.261.522l1.176-.114a1.45 1.45 0 0 1 1.584 1.584l-.114 1.176c-.047.48.149.953.522 1.26l.912.75a1.45 1.45 0 0 1 0 2.24l-.912.751a1.45 1.45 0 0 0-.522 1.26l.114 1.176a1.45 1.45 0 0 1-1.584 1.584l-1.176-.114a1.45 1.45 0 0 0-1.26.522l-.75.912a1.45 1.45 0 0 1-2.24 0l-.751-.912a1.45 1.45 0 0 0-1.26-.522l-1.176.114a1.45 1.45 0 0 1-1.584-1.584l.114-1.175a1.45 1.45 0 0 0-.522-1.26l-.912-.751a1.45 1.45 0 0 1 0-2.24l.912-.75c.373-.308.569-.78.522-1.261l-.114-1.176a1.45 1.45 0 0 1 1.584-1.584l1.175.114a1.45 1.45 0 0 0 1.26-.522z"></path></g><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="m27 13.192 1.732 1.582a.855.855 0 0 0 1.244-.091L33 11"></path></svg>`;
  }
};
if (!customElements.get("w-icon-phone-badge-check-42")) {
  customElements.define("w-icon-phone-badge-check-42", IconPhoneBadgeCheck42);
}
export {
  IconPhoneBadgeCheck42
};
//# sourceMappingURL=phone-badge-check-42.js.map
